<section class="section-parametre" [ngBusy]="{
    busy: busyGet,
    message: 'Veuillez patienter ...',
    backdrop: false
  }">
    <div class="">
        <div class="row clearfix">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="card">
                    <div class="body table-responsive">
                        <table class="table table-condensed table-striped table-hover">
                            <thead>
                                <tr>
                                    <th colspan="7">
                                        <div class="row mt-4">
                                            <div class="col-md-4">
                                                <input [(ngModel)]="itemToSearch.libelle" class="form-control custom-input pull-left" placeholder="Rechercher ..." (keyup)="currentPage = 1; getItems()" />
                                            </div>

                                            <div class="col-md-8">
                                                <button type="button" class="btn btn-md custom_btn_primary pull-right" (click)="openModal(null, templateCrud)">
                          <i class="fa fa-plus"></i>&nbsp; Ajouter
                        </button>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr class="custom-table-head">
                                    <th>
                                        <a style="cursor: pointer" (click)="currentPage = 1; getItems()" title="Actualiser">
                                            <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                                    </th>
                                    <th>Type</th>
                                    <th>Raison sociale</th>
                                    <th>P. à contacter</th>
                                    <th>Contact</th>
                                    <th>Compte contribuable</th>
                                    <th class="txt-align-center">Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of items; let indice = index">
                                    <td class="txt-align-center">{{ indice + 1 }}</td>
                                    <td>{{ item?.pharmacieTypeFournisseurLibelle }}</td>
                                    <td>
                                        {{ item?.raisonSocial }}
                                    </td>
                                    <td>{{item?.nomPersonneAContacter}}</td>
                                    <td>{{item?.numeroPersonneAContacter}}</td>
                                    <td>{{item?.numeroCompteContribuable}}</td>
                                    <td>
                                        <div class="custom-td-action">
                                            <a title="Modifier" (click)="openModal(item, templateCrud)" class="custom-btn-update">
                                                <i class="fa fa-edit"></i></a>
                                            <a title="Supprimer" (click)="confirmDelete(item)" class="custom-btn-delete">
                                                <i class="fa fa-trash"></i></a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr *ngIf="items && items.length > 0">
                                    <td colspan="8">
                                        <div class="row pagination-part">
                                            <div class="col-md-9" style="text-align: center">
                                                <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;" (pageChanged)="pageChanged($event)"></pagination>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="paginator-per-page">

                                                    <app-element-by-page-paginator (paginationChange)="changePaginationSize($event)" [defaultItemPerPage]="itemsPerPage"></app-element-by-page-paginator>

                                                    <span class="span_total_entree pull-right">Total : {{ totalItems }}</span>

                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="!items || items.length == 0">
                                    <td colspan="8">
                                        <div class="col-md-12 txt-align-center">
                                            Aucune données disponible
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Enregistrer une depense -->
<ng-template #templateCrud>
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            {{ itemToSave?.id ? "Modification d'un fournisseur" : "Enregistrement d'un fournisseur" }}
        </h4>

        <button mat-icon-button class="pull-right" (click)="modalRef.hide()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    </div>
    <div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
        <form class="m-1">
            <div class="row">

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Raison sociale :
            <span class="required_champs">*</span>
          </label>
                    <input class="form-control custom-input" placeholder="raisonSocial" autocomplete="off" [(ngModel)]="itemToSave.raisonSocial" name="raisonSocial" required type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Numéro compte contribuable :  </label>
                    <input class="form-control custom-input" placeholder="Numéro compte contribuable" autocomplete="off" [(ngModel)]="itemToSave.numeroCompteContribuable" name="numeroCompteContribuable" required type="text" />
                </div>


                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Numéro compte : </label>
                    <input class="form-control custom-input" placeholder="numéro compte" autocomplete="off" [(ngModel)]="itemToSave.numeroCompte" name="numeroCompte" required type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1">
                    <label>Type fournisseur :
            <span class="required_champs">*</span>
          </label>
                    <select name="typeFournisseurId" [(ngModel)]="itemToSave.typeFournisseurId" class="form-control custom-input">
            <option value="">Entrer type fournisseur</option>
            <option *ngFor="let item of itemsTypeFournisseurs" [(value)]="item.id">
              {{ item.libelle }}
            </option>
          </select>
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Contact :
            <span class="required_champs">*</span>
          </label>
                    <input class="form-control custom-input" placeholder="contact" autocomplete="off" [(ngModel)]="itemToSave.contact" name="contact" required type="text" />
                </div>

                <div class="col-md-3 col-sm-6 mb-3">
                    <label>Fax :</label>
                    <input class="form-control custom-input" placeholder="fax" autocomplete="off" [(ngModel)]="itemToSave.fax" name="fax" required type="text" />
                </div>

                <div class="col-md-3 col-sm-6 mb-3">
                    <label>Boite postale : </label>
                    <input class="form-control custom-input" placeholder="boitePostale" autocomplete="off" [(ngModel)]="itemToSave.boitePostale" name="boitePostale" required type="text" />
                </div>

                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Email :  </label>
                    <input class="form-control custom-input" placeholder="email" autocomplete="off" [(ngModel)]="itemToSave.email" name="email" required type="text" />
                </div>


                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>Localisation : </label>
                    <input class="form-control custom-input" placeholder="adresse" autocomplete="off" [(ngModel)]="itemToSave.adresse" name="adresse" required type="text" />
                </div>

                <div class="row">
                    <fieldset class="custom-fieldset">
                        <legend> Info personne à contacter </legend>

                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                                <label>Personne à contacter :
                  <span class="required_champs">*</span>
                </label>
                                <input class="form-control custom-input" placeholder="nomPersonneAContacter" autocomplete="off" [(ngModel)]="itemToSave.nomPersonneAContacter" name="nomPersonneAContacter" required type="text" />
                            </div>

                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-3">
                                <label>Numéro personne à contacter :
                  <span class="required_champs">*</span>
                </label>
                                <input class="form-control custom-input" placeholder="numeroPersonneAContacter" autocomplete="off" [(ngModel)]="itemToSave.numeroPersonneAContacter" name="numeroPersonneAContacter" required type="text" />
                            </div>
                        </div>

                    </fieldset>

                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer modal-footer-custom">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
            <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right" [disabled]="!itemToSave.libelle" [class.auth-spinner]="loading" [disabled]="loading">
        {{ itemToSave?.id ? "Modifier" : "Enregistrer" }}
      </button>

            <button type="button" class="btn btn-md btn-cancel pull-right" (click)="modalRef.hide()">
        Annuler
      </button>
        </div>
    </div>
</ng-template>